module.exports = __webpack_public_path__ + "img/zec.0355dfef.svg";